/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = {
  updateProductItem: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'remove quick view if product tag true',
      enabled: true,
      apply: () => ({
        afterRender(element){
          let productData = element.getParams().props.product;
          let productItem = document.querySelector('.boost-sd__product-item[data-product-id="' + productData.id + '"]');

          if (productData && productItem) {
               const hasTag = productData.tags.find(tag => tag == "bundle")
               if (hasTag && productItem.querySelector(".boost-sd__product-item .boost-sd__button")) productItem.querySelector(".boost-sd__product-item .boost-sd__button").style.display = 'none'
             }

        }
      }),
    });
  }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItem]);
